module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/bluetooth-7ef4c5cba15fdfc8bc01dc4bad792c97.svg";